import { render, staticRenderFns } from "./PageBackground.vue?vue&type=template&id=7aa63e65&scoped=true&"
import script from "./PageBackground.vue?vue&type=script&lang=js&"
export * from "./PageBackground.vue?vue&type=script&lang=js&"
import style0 from "./PageBackground.vue?vue&type=style&index=0&id=7aa63e65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa63e65",
  null
  
)

export default component.exports